import React, { useRef } from "react";
import Papa from 'papaparse';
import Button from '@material-ui/core/Button';
import "tabulator-tables/dist/css/tabulator.min.css";
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';

const fields = ['customID', 'message_prefix', 'c', 'd', 'serialNo', 'notes', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't'];

const styles = {
    btn: {
        color: "#03a9f4",
    }
};

const ZoneCsvParseButton = ({ changeTableData }) => {
    const importFileRef = useRef(null);

    const parse = () => {
        const file = importFileRef.current?.files[0];
        if (file) {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                transformHeader: (header, index) => {
                    if (index < fields.length) {
                        return fields[index];
                    }
                    return header;
                },
                complete: (results) => {
                    const filteredData = results.data.filter(v => v.message_prefix);
                    const transformedData = filteredData.map(element => ({
                        customID: element.customID,
                        message_prefix: element.message_prefix,
                        notes: element.notes,
                        serialNo: element.serialNo
                    }));
                    changeTableData(transformedData);
                }
            });
        }
    };

    const uploadFileClick = () => importFileRef.current?.click();

    return (
        <div>
            <input 
                type="file" 
                ref={importFileRef} 
                accept='.xlsx, .xls, .csv' 
                onChange={parse} 
                style={{ display: 'none' }} 
            />
            <div>
                <Button style={styles.btn} onClick={uploadFileClick}>
                    <LibraryAddIcon />
                </Button>
            </div>
        </div>
    );
}

export default ZoneCsvParseButton;
